
export default function(price) {
    const base = Number(price).toString().split('.')[1]?.length || 2;

    return base <= 2
        ? 100
        : Math.pow(10, base);
}